import { useState, useCallback } from "react";

const useZoom = (
  fabricCanvasRef,
  baseScaleRef,
  setCanvasScale,
  updateCanvasSize, // Accept updateCanvasSize
  width, // Accept canvas width
  height, // Accept canvas height
  setCanvasDimensions // Accept setCanvasDimensions
) => {
  const [zoomLevel, setZoomLevel] = useState(1.0);

  const zoomIn = useCallback(() => {
    if (!fabricCanvasRef.current || !baseScaleRef.current) {
      console.warn("Zoom: Cannot zoom in, canvas or baseScale not ready");
      return;
    }
    setZoomLevel((prevZoom) => {
      const newZoom = Math.min(prevZoom + 0.1, 5.0);
      const effectiveScale = baseScaleRef.current * newZoom;
      fabricCanvasRef.current.setZoom(effectiveScale);
      setCanvasScale(effectiveScale);
      console.log("Zoom: Zoomed in", { zoomLevel: newZoom, effectiveScale });
      return newZoom;
    });
  }, [fabricCanvasRef, baseScaleRef, setCanvasScale]);

  const zoomOut = useCallback(() => {
    if (!fabricCanvasRef.current || !baseScaleRef.current) {
      console.warn("Zoom: Cannot zoom out, canvas or baseScale not ready");
      return;
    }
    setZoomLevel((prevZoom) => {
      const newZoom = Math.max(prevZoom - 0.1, 0.1);
      const effectiveScale = baseScaleRef.current * newZoom;
      fabricCanvasRef.current.setZoom(effectiveScale);
      setCanvasScale(effectiveScale);
      console.log("Zoom: Zoomed out", { zoomLevel: newZoom, effectiveScale });
      return newZoom;
    });
  }, [fabricCanvasRef, baseScaleRef, setCanvasScale]);

  return { zoomLevel, zoomIn, zoomOut };
};

export default useZoom;
